import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare var require: any; 
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

try {   // for browsers
  var global = global || window;
  // Browser Support: make buffer, that emulates node's Buffer API, available globally in the browser
  global.Buffer = require("buffer").Buffer;
  // Browser Support: make process, that emulates node's Process API, available globally in the browser
  global.process = require("process");
}
catch (e) {
  // "window is not defined" for node.js
}

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}
